<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <venta-producto v-for="(producto, id) in this.productos" v-bind:key="id" v-bind:producto="producto" v-bind:disabled = "disabled" v-on:cambio-total = "calcularTotal()"></venta-producto>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'venta-seleccionar-producto',
  props: {
    productos: {
      1: {
        nombre: '',
        precio: 0,
        cantidad: 0,
        total: 0,
        urlImg: ''
      }
    },
    disabled: false
  },
  methods: {
    calcularTotal () {
      var total = 0
      for (var idDetalle in this.productos) {
        total += this.productos[idDetalle].total
      }
      this.$emit('total-seleccion', total)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VentaSeleccionarProducto.vue